import styled from 'styled-components';
import { Tooltip as TooltipComponent } from '@/components/Tooltip';

export const Root = styled.span`
  display: inline-flex;
  width: 20px;
  height: 20px;
  vertical-align: middle;
`;

export const Tooltip = styled(TooltipComponent)`
  && {
    width: 88px;
    padding: 8px 10px;
    border-radius: 9px;
    text-align: center;
    font-size: 12px;
  }
`;

export const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 2px;
  border: 0;
  color: ${({ theme }) => theme.palette.primary.labels};
  background-color: transparent;
  cursor: pointer;
  vertical-align: middle;

  &:disabled {
    cursor: default;
    opacity: 0.45;
  }

  svg {
    flex-shrink: 0;
  }
`;
